export default __webpack_public_path__ + "static/media/UniversLTStd-Bold.0464cecd.otf";